<p-scrollPanel [style]="{ width: '100%', height: '100%' }">
  <form [formGroup]="form.formGroup" class="h-full min-h-0 flex flex-col">

    <div class="field z-[2]">
      <label>Choke Name</label>
      <p-inputgroup>
        <input type="text" pInputText formControlName="name" />
      </p-inputgroup>
    </div>
    
    <br>

    <p-tabs value="0" class="flex flex-col flex-1 min-h-0">
      <p-tablist>
        <p-tab value="0">Choke</p-tab>
        <p-tab value="1">Cv Schedule</p-tab>
      </p-tablist>

      <p-tabpanels class="w-full h-full flex-1 min-h-0">
        <p-tabpanel value="0">
          <div class="flex flex-col space-y-2">
            <div class="flex flex-col">
              <label>Critical Flow Factor (Liquid)</label>
              <app-validated-number-input
                [id]="'criticalLiquidFlowFactor'"
                [control]="control('criticalLiquidFlowFactor')"
                [value]="control('criticalLiquidFlowFactor').value"
                [validation]="{min: 0, max: 1}"
                [unit]="''"
                [inline]="false"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label>Critical Flow Factor (Vapor)</label>
              <app-validated-number-input
                [id]="'criticalVaporFlowFactor'"
                [control]="control('criticalVaporFlowFactor')"
                [value]="control('criticalVaporFlowFactor').value"
                [validation]="{min: 0, max: 1}"
                [unit]="''"
                [inline]="false">
              </app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label>Piping Geometry Factor</label>
              <app-validated-number-input
                [id]="'pipingGeometryFactor'"
                [control]="control('pipingGeometryFactor')"
                [value]="control('pipingGeometryFactor').value"
                [validation]="{min: 0, max: 10000000}"
                [unit]="''"
                [inline]="false"
              ></app-validated-number-input>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1" class="h-full min-h-0">
            <div class="flex w-full gap-2">
              <div class="flex flex-col">
                <label>% Open</label>
                <p-inputNumber class="w-full" (onInput)="interpolateCv($event)" [minFractionDigits]="1"
                  [disabled]="flowCoefficientSchedule?.length <= 1"></p-inputNumber>
              </div>

              <div class="flex flex-col">
                <label>Interpolated Cv</label>
                <p-inputNumber class="w-full" disabled="true" placeholder="{{ interpolatedCv }}"></p-inputNumber>
              </div>
            </div>

            @if (chokesUiEntity$) {
              <div class="pt-3 flex">
                <p-toggleswitch inputId="chokeTablePlot" (onChange)="tablePlotToggle($event)" [(ngModel)]="chokesUiEntity$.selectedResultsDisplay"
                  [ngModelOptions]="{standalone: true}" binary="true">
                </p-toggleswitch>
                <label for="chokeTablePlot" class="ml-2">Table/Plot</label>
              </div>
            }

            <div class="w-full h-full min-h-0 flex flex-col">

              @if (chokesUiEntity$?.selectedResultsDisplay) {
                <app-xy-line-plot
                  [hidden]="!chokesUiEntity$?.selectedResultsDisplay" [plotData]="plot.data"
                  [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="choke?.name"
                  [downloadPlotName]="downloadPlotName" [reverseAutoRange]="true"
                  plotTitle="Chokes"
                  [btmMargin]="60"
                  [xyLinePlotStore]="chokesStore"
                  class="block flex-1 min-h-0"
                ></app-xy-line-plot>
              }

              <app-units-grid-input
                [hidden]="chokesUiEntity$?.selectedResultsDisplay"
                [tableTitle]="'Flow Coefficient Schedule'"
                [rows]="cvScheduleRows"
                [columns]="cvScheduleColumns"
                [autoHeight]="true"
                [autoHeightOffset]="250"
                [allowDeleteRows]="true"
                [minRows]="1"
                [createRow]="createChokeCvScheduleRow"
                [commitMode]="'debounced'"
                [commitDebounceMs]="300"
                (cellEdited)="onCvScheduleGridChange()"
                (commitRequested)="onCvScheduleGridChange()"
                (rowDeleted)="onCvScheduleRowDeleted($event)"
                (rowsReset)="onCvScheduleGridChange()"
                (pasteApplied)="onCvScheduleGridChange()"
              />
            </div>

        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

  </form>
</p-scrollPanel>